import Flagged from 'flagged/components/Flagged';

const routes = {
  path: 'flagged',
  element: <Flagged />
};

export default routes;
